export function FinanceEntryTypeComponent(props: { type: string }) {
  const { type } = props;
  return (
    <span style={{color: type === 'R' ? 'green' : 'red'}}>{type === 'R' ? 'Receita' : 'Despesa'}</span>
  )
}